import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { createNewGame } from '../../services/GamesService'
import { getLotteries } from '../../services/LotteriesService'
import { i18n } from '../../utils/translates/i18n'

export default function ModalNewGame({ doGetGames }) {
  const token = sessionStorage.getItem('token')
  const btnClose = useRef('')

  const DEFAULT_POST = {
    mainLotteryId: '',
    lottery: '',
    drawDate: '',
    drawHours: 20,
    drawMinutes: 0,
    drawDue: '',
    dueHours: 19,
    dueMinutes: 45,
  }

  const [post, setPost] = useState(DEFAULT_POST)
  const [lotteries, setLotteries] = useState([])

  const doGetLotteries = async () => {
    const success = await getLotteries(token, 1, 100, 4)
    if (success.status) setLotteries(success.list.rows)
  }

  useEffect(() => {
    doGetLotteries()
  }, [])

  const onSelectLottery = e => {
    const selected = lotteries.find(l => String(l.id) === String(e.target.value))
    if (selected) setPost({ ...post, mainLotteryId: selected.id, lottery: selected.lottery })
    else setPost({ ...post, mainLotteryId: '', lottery: '' })
  }

  const doSave = async () => {
    if (!post.mainLotteryId || !post.drawDate || !post.drawDue)
      return toast.error('Preencha todos os campos obrigatórios')

    const success = await createNewGame(post, token)
    if (success.status) {
      toast.success('Concurso criado com sucesso!')
      doGetGames()
      setPost(DEFAULT_POST)
      btnClose.current.click()
    } else {
      toast.error(i18n.t(success.msg) || 'Erro ao criar concurso')
    }
  }

  return (
    <div className="modal fade" id="modalNewGame" tabIndex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Novo Concurso</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={btnClose} />
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold">Loteria *</label>
              <select className="form-select" value={post.mainLotteryId} onChange={onSelectLottery}>
                <option value="">Selecione a loteria</option>
                {lotteries.map(l => (
                  <option key={l.id} value={l.id}>{l.lottery}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Data do Sorteio *</label>
              <input
                type="date"
                className="form-control"
                value={post.drawDate}
                onChange={e => setPost({ ...post, drawDate: e.target.value })}
              />
              <div className="d-flex gap-2 mt-2">
                <div className="input-group">
                  <span className="input-group-text">Hora</span>
                  <input
                    type="number" min={0} max={23}
                    className="form-control"
                    value={post.drawHours}
                    onChange={e => setPost({ ...post, drawHours: parseInt(e.target.value) })}
                  />
                </div>
                <div className="input-group">
                  <span className="input-group-text">Min</span>
                  <input
                    type="number" min={0} max={59}
                    className="form-control"
                    value={post.drawMinutes}
                    onChange={e => setPost({ ...post, drawMinutes: parseInt(e.target.value) })}
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Prazo para Apostas *</label>
              <input
                type="date"
                className="form-control"
                value={post.drawDue}
                onChange={e => setPost({ ...post, drawDue: e.target.value })}
              />
              <div className="d-flex gap-2 mt-2">
                <div className="input-group">
                  <span className="input-group-text">Hora</span>
                  <input
                    type="number" min={0} max={23}
                    className="form-control"
                    value={post.dueHours}
                    onChange={e => setPost({ ...post, dueHours: parseInt(e.target.value) })}
                  />
                </div>
                <div className="input-group">
                  <span className="input-group-text">Min</span>
                  <input
                    type="number" min={0} max={59}
                    className="form-control"
                    value={post.dueMinutes}
                    onChange={e => setPost({ ...post, dueMinutes: parseInt(e.target.value) })}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">
              Cancelar
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={doSave}>
              <i className="fas fa-plus me-2"></i>Criar Concurso
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
